module.exports = __webpack_public_path__ + "img/sail-croatia-dark.b33b5acc.svg";